// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"9f8513d6","361":"912bbfa2","608":"f6269376","674":"c2b04a8f","735":"fd66ecb8","923":"4b5ee83c"}[chunkId] + ".chunk.js";
};